import { Button, Form, Icon, Input, Select } from 'antd'
import React, { useState } from 'react'
import { alertify, handleApiExceptions } from '../../../../../../app_methods';
import { VendorInvoice } from '../../../../../../models/vendorPayouts';
import { Text3 } from '../../../../../../styles'

let RecordOfflinePaymentForm = (props) => {
    const { form, vendorInvoice } = props;
    const { getFieldDecorator, validateFields } = form;
    const [isSaving, setIsSaving] = useState(false);
    const [paymentMode, setPaymentMode] = useState(false);

    const validations = VendorInvoice.validations;

    const handleSaveResponse = (values, response) => {
        setIsSaving(false);
        alertify("Success", `Invoice Payment successfully.`, "success");
        props.fetchList();
        props.toggleRecordOfflinePaymentModal();
    }

    const recordOfflinePayment = async (values) => {
        const response = await vendorInvoice.record_offline_payment(values);
        if (!response.success) {
            setIsSaving(false);
            handleApiExceptions(response);
            return;
        }
        handleSaveResponse(values, response);
    }

    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (err) return;
            setIsSaving(true);
            recordOfflinePayment(values);
        });
    };

    return (
        <>
            <Form onSubmit={onSubmit}>
                <Form.Item label="Payment Mode">
                    {getFieldDecorator("payment_mode", {
                        initialValue: undefined,
                        rules: validations.payment_mode
                       
                    })(<Select placeholder="Select Payment Mode">
                        <Select.Option value="Cash">Cash</Select.Option>
                        <Select.Option value="DD">Demand Draft</Select.Option>
                        <Select.Option value="Cheque">Cheque</Select.Option>
                        <Select.Option value="NetBanking">Net Banking</Select.Option>
                        <Select.Option value="Other">Other</Select.Option>
                    </Select>)}
                </Form.Item>

                <Form.Item label="Reference Number">
                    {getFieldDecorator("payment_reference_number", {
                        initialValue: (form.getFieldValue("payment_mode") === 'Cash' || form.getFieldValue("payment_mode") === 'Other') ? "" : undefined,
                        rules:(form.getFieldValue("payment_mode") === 'Cash' || form.getFieldValue("payment_mode") === 'Other') ? undefined : validations.payment_reference_number
                    })(
                        <Input
                            placeholder='Payment Reference Number'
                            autoComplete="off"
                            disabled={(form.getFieldValue("payment_mode") === 'Cash' || form.getFieldValue("payment_mode") === 'Other')}
                        />
                    )}
                </Form.Item>
                <div className="w-100 d-flex justify-content-end mt-4">
                    <Button htmlType="submit" type="primary" loading={isSaving}>
                        Submit
                    </Button>
                </div>
            </Form>
        </>
    )
}


RecordOfflinePaymentForm = Form.create()(RecordOfflinePaymentForm);
export { RecordOfflinePaymentForm };
